import Card from './Card';
export default Card;



// WEBPACK FOOTER //
// ./src/components/Card/index.js